import { ColorHelper } from "helpers";
import { MATERIAL_REQUIREMENT_STATUS } from "common";
import StatusCell from "./StatusCell";
import { EMaterialRequirement } from "model/Type/EMaterialRequirement";
import { I18nTranslator } from "utils/i18n";

const MaterialRequirementStatusCell = ({
  value,
}: {
  value: EMaterialRequirement;
}) => {
  return (
    <StatusCell bgcolor={ColorHelper.getMaterialRequirementStatusColor(value)}>
      {I18nTranslator(
        MATERIAL_REQUIREMENT_STATUS.find((status) => status.type === value)
          ?.name!
      )}
    </StatusCell>
  );
};

export default MaterialRequirementStatusCell;
